import type { RouteRecordRaw } from 'vue-router'

import type { RedirectRouteRelative } from '@/utilities/routers'

import { routeDistributionListsRoot } from '@/routers/routes/mainRoutes/routeMarketing/routeNewsletter/distributionListRoutes'
import {
  routeNewsletterArticlesHome,
  routeNewsletterArticlesRoot,
} from '@/routers/routes/mainRoutes/routeMarketing/routeNewsletter/newsletterArticleRoutes'
import { routeSubscribersRoot } from '@/routers/routes/mainRoutes/routeMarketing/routeNewsletter/subscriberRoutes'

const routeNewsletterHome: RouteRecordRaw = {
  name: 'newsletter-home',
  path: '',
  redirect: routeNewsletterArticlesHome,
}

const routeNewsletterRoot: RouteRecordRaw = {
  children: [
    routeNewsletterHome,
    routeNewsletterArticlesRoot,
    routeSubscribersRoot,
    routeDistributionListsRoot,
  ],

  path: 'newsletter',
}

const redirectNewsletter: RedirectRouteRelative = {
  name: routeNewsletterHome.name,
}

export { redirectNewsletter, routeNewsletterHome, routeNewsletterRoot }
